/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const DOM_DELTA_PIXEL = 0;
const DOM_DELTA_LINE = 1;
const DOM_DELTA_PAGE = 2;

export function getWheelZoomAmount(event: WheelEvent) {
  let multiplier = 0;
  let {deltaMode} = event;
  switch (deltaMode) {
    case DOM_DELTA_PIXEL:
      multiplier = 1 / 200.0;
      break;
    case DOM_DELTA_LINE:
      multiplier = 1 / 10.0;
      break;
    case DOM_DELTA_PAGE:
      multiplier = 2;
      break;
  }
  // EyeWire II: one wheel event zooms at most about 2.7 times. Firefox can
  // report a notch as a page, or as a very large pixel count, and the 3D view
  // went from a cell to 145 trillion times too far out in a few notches
  // (Nseraf #182, 2026-10-21).
  return Math.exp(Math.max(-1, Math.min(1, event.deltaY * multiplier)));
}
